export default "__VITE_ASSET__Omp8um0l__"